import * as ng from 'angular';

export const StRatio = () => (<angular.IDirective>{

    link: (scope: any, element: JQLite, attr: any) => {
        let ratio = +(attr.stRatio);
        element.css('width', ratio + '%');
    }
});



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/third/smart-table/st-ratio/st-ratio.directive.ts